import { getFileSrc } from '@/utils/utilities';
import { Loader } from './Loader';
import { Texture, MeshStandardMaterial, Group, Object3DEventMap } from 'three';

export class AssetsLib {
	private loader = Loader.getInstance();
	texturesCache = new Map<string, Texture>();
	materialCache = new Map<string, MeshStandardMaterial>();
	models = new Map<string, Group<Object3DEventMap>>();

	private static instance: AssetsLib;

	private constructor() {}

	static getInstance() {
		if (!AssetsLib.instance) AssetsLib.instance = new AssetsLib();
		return AssetsLib.instance;
	}

	async getModel(path: string) {
		let model = this.models.get(path);

		if (!model) {
			const gltf = await this.loader.gltfLoader.loadAsync(getFileSrc(path));
			model = gltf.scene;

			this.models.set(path, model);
		}

		return model.clone();
	}
}
